import React, { Component } from "react";
import discountCodeDollar from "../images/eshop/checkout/discount-code-dollar.svg";
import "../css/Coupon.css";
import { Translation, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { coupon } from "../models";

export class Coupon extends Component {
  state = {
    couponValue: ""
  };

  handleChange = event => {
    const value = event.target.value;
    this.setState({
      couponValue: value
    });
  };

  handleSubmit = () => {
    const { postCouponCode, couponErrorText } = this.props;
    const { couponValue } = this.state;
    if (couponValue.trim() === "") {
      // 顯示錯誤提示文字
      couponErrorText(
        <Translation>{t => t("checkout.pleaseUseValidCode")}</Translation>
      );
    } else {
      // 送出優惠代碼
      postCouponCode(couponValue.trim());
      this.setState({
        couponValue: ""
      });
    }
  };

  handleDelete = data => {
    const { deleteCouponCode } = this.props;
    const code = data.couponCode;
    // 刪除優惠代碼
    deleteCouponCode(code);
  };

  render() {
    const { t, myBagData, errorText, isLogin } = this.props;
    const { couponValue } = this.state;
    return (
      <React.Fragment>
        {isLogin ? (
          <div className={"checkout_discountCode_wrap"}>
            <div className="title">
              <Translation>{t => t("checkout.useCoupon")}</Translation>
            </div>
            <div>
              <input
                type="text"
                id="checkout_discountCode"
                name="checkout_discountCode"
                placeholder={t("checkout.enterpromotionCodeVoucher")}
                required
                value={couponValue}
                onChange={this.handleChange.bind(this)}
              />
              <div className="appliedCodeTag_wrap">
                {myBagData.coupons && Array.isArray(myBagData.coupons) ? (
                  <React.Fragment>
                    <div style={{ marginBottom: "1.5em" }}>
                      {myBagData.coupons.map((data, index) => (
                        <React.Fragment key={index}>
                          {data.showUnusedCoupon ? (
                            <span className="appliedCodeTag" key={index}>
                              <img
                                className="icon"
                                src={discountCodeDollar}
                                alt=""
                              />
                              <span className="text">{data.couponName}</span>
                              <button
                                type="button"
                                className="closeBtn"
                                onClick={this.handleDelete.bind(this, data)}
                              >
                                <span
                                  className="stroke"
                                  aria-hidden="true"
                                ></span>
                                <span
                                  className="stroke"
                                  aria-hidden="true"
                                ></span>
                              </button>
                            </span>
                          ) : null}
                        </React.Fragment>
                      ))}
                    </div>
                    {myBagData.coupons.map((data, index) =>
                      data.message ? (
                        <p className="text-error" key={index}>
                          {data.message}
                        </p>
                      ) : null
                    )}
                  </React.Fragment>
                ) : null}
              </div>
              {errorText ? <p className="text-error">{errorText}</p> : null}
            </div>
            <div>
              <a className="blockBtn" onClick={this.handleSubmit}>
                <Translation>{t => t("checkout.applyNow")}</Translation>
              </a>
            </div>
          </div>
        ) : null}
      </React.Fragment>
    );
  }
}

const TransCoupon = withTranslation()(Coupon);

export const mapStateToProps = state => {
  return {
    myBagData: state.myBag.myBagData,
    errorText: state.coupon.errorText,
    isLogin: state.login.signed
  };
};

export const mapDispatchToProps = () => {
  return {
    postCouponCode: code => coupon.actions.postCouponCode(code),
    deleteCouponCode: code => coupon.actions.deleteCouponCode(code),
    couponErrorText: text => coupon.actions.couponErrorText(text)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransCoupon);
